import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, onAuthStateChanged, connectAuthEmulator, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

// Your Firebase config (from the Firebase Console)
const firebaseConfig = {
    apiKey: process.env.GATSBY_FIREBASE_API_KEY,
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
    storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.GATSBY_FIREBASE_APP_ID,
    measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID
  };


export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/auth.user
    const uid = user.uid;
    console.log("User logged in!")
    // ...
  } else {
    // User is signed out
    // ...
    console.log("User logged out!")
  }
});

let anonymousSignInPromise = null;

// Function to sign in anonymously
export const anonymouslySignIn = async () => {
  // auth.currentUser reads null synchronously until Firebase finishes
  // restoring any persisted session (e.g. a previous Google sign-in) from
  // IndexedDB. Without waiting here, a call that races ahead of that
  // restoration would see no user, sign in anonymously, and silently
  // replace the about-to-be-restored Google session with a fresh
  // anonymous one — this is what caused signed-in sessions to appear lost
  // on reload.
  await auth.authStateReady();

  if (auth.currentUser) {
    return auth.currentUser;
  }

  // Also dedupe concurrent callers (e.g. several API requests firing at
  // once on page load) so they share one signInAnonymously() call instead
  // of racing to create separate anonymous accounts.
  if (!anonymousSignInPromise) {
    anonymousSignInPromise = signInAnonymously(auth)
      .then((userCredential) => userCredential.user)
      .catch((error) => {
        console.error("Error signing in anonymously:", error);
        return null;
      })
      .finally(() => {
        anonymousSignInPromise = null;
      });
  }
  return anonymousSignInPromise;
};

export const getCurrentUser = async () => {
  return await anonymouslySignIn()
}

// Function to sign in with Google
export const signInWithGoogle = async () => {
  const userCredential = await signInWithPopup(auth, new GoogleAuthProvider());
  return userCredential.user;
};

// Function to sign out the current user
export const signOutUser = async () => {
  await signOut(auth);
};